import type { TextareaHTMLAttributes } from "react";
import { useId } from "react";
import { FieldWrapper } from "./FieldWrapper";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  helper?: string;
  error?: string;
  required?: boolean;
}

export default function Textarea({
  label,
  helper,
  error,
  required,
  className = "",
  id,
  rows = 4,
  ...rest
}: TextareaProps) {
  const autoId = useId();
  const areaId = id ?? autoId;

  return (
    <FieldWrapper label={label} helper={helper} error={error} required={required} htmlFor={areaId}>
      <textarea
        id={areaId}
        rows={rows}
        className={`w-full rounded-lg border bg-white px-3.5 py-2.5 text-sm text-ink placeholder:text-ink-muted focus:outline-none focus:ring-2 ${
          error
            ? "border-danger focus:ring-danger/30"
            : "border-slate-300 focus:border-primary-500 focus:ring-primary-500/30"
        } ${className}`}
        aria-invalid={!!error}
        {...rest}
      />
    </FieldWrapper>
  );
}